/**
 * 粮小助 AI 助手 来源配置 API.
 * 后端: /hl-drying/drying/ai-helper/config/** (hl-drying 模块 aiHelperConfig)
 *
 * 前端启动时拉激活配置拼 iframe 地址; 拉不到(后端未发版/演示环境)走本地兜底(见 constants/aiHelper.js).
 */
import request from '@/utils/request'

const PREFIX = '/hl-drying/drying/ai-helper/config'

/**
 * 取当前激活的 AI 助手来源配置
 * @returns {Promise<Object|null>} { configKey, configName, baseUrl, chatToken } 或 null(无激活行)
 */
export function fetchActiveAiHelperConfig() {
  return request({
    url: `${PREFIX}/active`,
    method: 'get'
  }).then(res => {
    // request.js 拦截器已返回 result 本身; 兼容直接返 data 的接口
    const d = res && res.result !== undefined ? res.result : res
    return d && d.baseUrl && d.chatToken ? d : null
  })
}
